export default function setError(error = {}) {
	return { type: "SET_ERROR", error };
}
